import axios from 'axios';
import * as constants from './constants';

const instance = axios.create({
  baseURL: constants.BASE_URL,
});

instance.interceptors.request.use(function (config) {
  // Do something before request is sent

  if (config.headers){
    config.headers["Access-Control-Allow-Origin"] = "*"
  }else{
    config.headers["Access-Control-Allow-Origin"] = "*"
  }

  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

export default instance;



// WEBPACK FOOTER //
// ./src/config/axios.js